
import { mapState } from 'vuex'
import LayoutMixin from '@/mixins/layout'
import SupportTop from '@/components/page/support-top.vue'
// import SupportNav from '@/components/page/support-nav.vue'
export default {
  components: {
    // SupportNav,
    SupportTop,
  },
  mixins: [LayoutMixin],
  async asyncData({ app }) {
    try {
      const res = await app.$API.support.getSupportContent({ type: 19 })
      const { name = '', content = '' } = res[0] || {}
      return {
        name,
        content,
      }
    } catch (e) {
      return {
        name: '',
        content: '',
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      site: (state) => state.site,
    }),
    isSG() {
      return this.site.toUpperCase() === 'SG'
    },
    getMainTitle() {
      return this.$t('navs.fuelSurcharge')
    },
  },
}
